import { useCallback, useEffect, useState } from 'react';

const RETRY_AFTER_MS = 3000;
const MAX_RETRIES = 10;

const useRetryTimer = ({ canRetry, retry }) => {
  useEffect(() => {
    if (!canRetry) {
      return undefined;
    }
    const timer = setTimeout(retry, RETRY_AFTER_MS);
    return () => clearTimeout(timer);
  }, [canRetry, retry]);
};

const useCountingRetry = ({ isCounting, pageReady }) => {
  const [retries, setRetries] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const retry = useCallback(() => {
    setIsFetching(true);
    setRetries((count) => count + 1);
    pageReady.current.refreshPage();
  }, [pageReady]);
  useRetryTimer({
    canRetry: isCounting && !isFetching && retries < MAX_RETRIES,
    retry,
  });
  return {
    isExhausted: retries >= MAX_RETRIES && !isFetching,
    finishRequest: () => setIsFetching(false),
  };
};

export default useCountingRetry;
